var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_vm._t("default",function(){return [(_vm.label)?_c('span',{staticClass:"p-avatar-text"},[_vm._v(_vm._s(_vm.label))]):(_vm.icon)?_c('span',{class:_vm.iconClass}):(_vm.image)?_c('img',{attrs:{"src":_vm.image}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }